export const voucherTrackerUserId = 13738;

export const minimumPackageAmountToShow = 200;
export const recurrenceFallbackPercentageDiscount = 5;

export const getRecurrenceBenefitValue = (purchaseRecurrenceBenefit = {}) => {
    const discountType = purchaseRecurrenceBenefit?.value?.discountType || 'percentage';
    const fallbackValue = discountType === 'percentage' ? recurrenceFallbackPercentageDiscount : 0;
    const discountValue = parseFloat(purchaseRecurrenceBenefit?.value?.value ?? fallbackValue);

    return {
        discountType,
        discountValue,
        discountText: discountType === 'percentage' ? `${discountValue}%` : null,
    };
}
